import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuthState } from '@/api/auth'
import { ErrorText, PageSpinner } from '@/components/ui'

export function AdminGuard({ children }: { children: ReactNode }) {
  const auth = useAuthState()
  if (auth.isPending) return <PageSpinner />
  if (auth.isError) return <ErrorText error={auth.error} />
  if (auth.data?.user?.role !== 'admin' || auth.data.user.requires_email || auth.data.user.requires_totp_setup) return <Navigate to="/" replace />
  return children
}
